// extracted by mini-css-extract-plugin
export default {"words":"index_words_GK38R"};